import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "GraphingTool" })((theme) => ({
  page: {
    margin: "20px",
  },
}));
